import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto text-center py-16">
      <XCircle className="w-14 h-14 text-slate-300 mx-auto" />
      <h1 className="font-display text-2xl font-bold text-slate-900 mt-3">Ödeme iptal edildi</h1>
      <p className="text-slate-500 mt-2">Sorun değil! İstediğin zaman tekrar deneyebilirsin.</p>
      <Button data-testid="retry-subscribe-btn" onClick={() => navigate("/abonelik")} className="mt-6 bg-indigo-600 hover:bg-indigo-700 rounded-xl font-bold px-8 py-6">
        Tekrar Dene
      </Button>
    </div>
  );
}
